import PropTypes from 'prop-types';
import React from 'react';
import './style.css';

class NotificationBar extends React.Component {
  render() {
    const { bars, notificationClicked } = this.props.notification;
    const { pathname } = this.props.location;

    const doms = bars.map(function(bar, index) {
      return (
        !notificationClicked && (
          <div
            key={index}
            className={
              pathname === '/reports/invoices' ||
              pathname === '/reports/transactions'
                ? `mk-alert-box-trx-inv trans-1 ${bar.level}`
                : `mk-alert-box trans-1 ${bar.level}`
            }
          >
            <div className="container">
              <div
                className={
                  bar.message.length > 37 ? 'mk-alert pad2' : 'mk-alert pad11'
                }
              >
                <div>{bar.message}</div>
              </div>
            </div>
          </div>
        )
      );
    }, this);

    return <div>{doms}</div>;
  }
}

NotificationBar.propTypes = {
  notification: PropTypes.object,
  location: PropTypes.object,
};
export default NotificationBar;
